export const ID_GB = {
    NORMAL: "1",
    KAKAO: "2",
    GOOGLE: "3",
    APPLE: "11",
}

export const ERROR_CODE = {
    SUCCESS: "0000",
    EXIST_SUB_DOMAIN: "1000",
    EXIST_COMPANY: "3000",
    EXIST_EMAIL: "5000",
}

export const ENCRYPT = {
    SIMPLE: "Y",
    SERVER_TIME_CHECK: "YC"
}

export const MAIL = {
    GMAIL : {
        NAME : "GMAIL",
        WEB :   "https://mail.google.com/mail/u/0/",
        PLAY_STORE : "com.google.android.gm",
        APP_STORE : "https://apps.apple.com/kr/app/gmail-email-from-google/id422689480?ign-mpt=uo%3D4&l=ko&v0=WWW-APIN-ITSTOP100-FREEAPPS",
        SCHEME: "googlegmail://mail/",  // 임시로 기본 메일 앱 ( intent://mail.google.com/mail/#inbox)
    },
    OUTLOOK : {
        NAME : "OUTLOOK",
        WEB :  "https://outlook.live.com/mail/0/inbox" ,
        PLAY_STORE : "com.microsoft.office.outlook",
        APP_STORE : "https://apps.apple.com/kr/app/microsoft-outlook-email-calendar/id951937596",
        SCHEME: "ms-outlook://mail/", // 임시로 기본 메일 앱
    },
}
export const DEFAULT_SUB_DOMAIN = "team";

export const ACCESS_TYPE = {
    BROWSER : "BROWSER",
    WEB_VIEW : "WEB_VIEW",
}